export class BrowserMCPError extends Error {
    code;
    retryable;
    constructor(code, message, options = {}) {
        super(message, options.cause === undefined ? undefined : { cause: options.cause });
        this.name = "BrowserMCPError";
        this.code = code;
        this.retryable = options.retryable ?? false;
    }
}
export class BrowserMCPRemoteError extends BrowserMCPError {
    protocolCode;
    details;
    constructor(options) {
        super("REMOTE_ERROR", options.message, { retryable: options.retryable });
        this.name = "BrowserMCPRemoteError";
        this.protocolCode = options.protocolCode;
        this.details = options.details;
    }
}
//# sourceMappingURL=errors.js.map